import {Box, Button, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import {useSubPages} from "../../shared/components/page/SubPageProvider";
import {Application, formatApplication} from "./Application";
import {useCallback, useMemo} from "react";
import {Theme} from "@mui/system";
import {SMALL_SCREEN_BREAKPOINT} from "./ApplicationPage";
import {routePaths} from "../../shared/components/router/routes";

export function ApplicationHeaderNavigation(props: {
  application: Application
}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const smallScreens = useMediaQuery((theme: Theme) => theme.breakpoints.down(SMALL_SCREEN_BREAKPOINT));
  const {selectedSubPage, selectSubPage} = useSubPages();

  const onClick = useCallback(() => {
    if (!smallScreens) {
      navigate(routePaths.application)
    } else if (!selectedSubPage) {
      navigate(routePaths.application)
    } else {
      selectSubPage(undefined);
    }
  }, [navigate, selectedSubPage, selectSubPage, smallScreens]);

  const label = useMemo(() =>
    !smallScreens ?
      '< ' + t('Application.titleLong') :
      selectedSubPage ?
        '< ' + (formatApplication(props.application) || t('Application.titleNew')) :
        '< ' + t('Application.titleLong'), [selectedSubPage, props.application, t, smallScreens]);

  return (
    <Box sx={{width: 'fit-content', margin: 1}}>
      <Button variant={"text"} onClick={onClick}>{label}</Button>
    </Box>
  )
}
